module.exports = __webpack_public_path__ + "img/single-user.0169b0fd.svg";